// @ts-nocheck
import React, { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import useSlug from '../../../../hooks/useSlug'

import EmbeddedVideo from './EmbeddedVideo'

const S = {
    Container: styled.div`
        display: inline-block;
        height: 100%;
        width: auto;
        position: relative;
        margin: 0 auto;
        overflow: hidden;
    `,
    Placeholder: styled.img`
        display: inline-block;
        position: relative;
        height: 100%;
        width: auto;
        opacity: 0;
        @media (max-width: 932px) {
            width: 100%;
            height: auto;
        }
    `,
    Mask: styled.svg`
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: 50%;
        mix-blend-mode: multiply;
    `,
    Image: styled.img`
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    `,
    VideoThumbnail: styled.div`
        display: block;
        overflow: hidden;
        position: absolute;
        top: 12.5%;
        height: 24%;
        left: 69.6%;
        width: 15.7%;
        border-radius: 2px;
        z-index: 6;
    `,
    Logo: styled.img`
        display: block;
        top: 64.8%;
        height: 17.3%;
        left: 42.6%;
        width: 11.6%;
        position: absolute;
        object-fit: contain;
        border-bottom-left-radius: 11px;
    `,
    Artwork: styled.img`
        display: block;
        top: 15%;
        height: 63%;
        left: 26%;
        width: 49%;
        position: absolute;
        object-fit: cover;
    `,
}

export interface StandLargeProps {
    background: string
    color: string
    logo: string
    video?: { url?: string }
    slug?: string
}

const StandLarge: FC<StandLargeProps> = ({
    background,
    color,
    logo,
    video = null,
    slug
}: StandLargeProps) => {
    const boothSlug = useSlug('boothSlug')
    const [isActiveBooth, setIsActiveBooth] = useState(false)
    useEffect(() => {
        setIsActiveBooth(boothSlug === slug)
    }, [boothSlug, slug])
    return (
        <S.Container>
            <S.Placeholder
                src="/assets/booths/booth_stand_placeholder_2034x745.png"
            />
            {background && (
                <S.Artwork src={background} alt="" style={{ zIndex: 1 }} />
            )}
            <S.Image
                src="/assets/booths/Appendee_Stand_Large_Base.png"
                alt=""
                style={{ zIndex: 4 }}
            />
            <S.Mask
                xmlns="http://www.w3.org/2000/svg"
                width="2036"
                height="747"
                viewBox="0 0 2036 747"
                style={{ zIndex: 3 }}
            >
                <defs>
                    <polygon
                        id="mask-large-a"
                        points="0 .981 130.043 .981 130.043 124.061 0 124.061"
                    />
                </defs>
                <g fill="none" fillRule="evenodd" transform="translate(1 1)">
                    <path
                        fill={color}
                        d="M869.1675 472.7049L1101.6605 472.7049 1101.6605 482.7809 868.9765 482.7809C868.8565 485.0929 868.6875 486.8589 868.6865 488.6259 868.6705 519.1309 868.6545 549.6359 868.6845 580.1409 868.6985 595.0539 875.7655 602.0519 890.8215 602.0489 958.9885 602.0359 1027.1555 601.9969 1095.3225 601.9559 1096.9465 601.9549 1098.5715 601.8189 1100.4945 601.7329 1100.6615 598.6529 1100.8105 595.8959 1100.9835 592.6969L1122.3725 592.6969C1119.6735 586.9399 1116.1015 582.0869 1115.2995 576.8119 1114.5335 571.7629 1116.6445 566.2759 1117.5475 560.6199 1119.3745 560.5219 1120.9905 560.3609 1122.6055 560.3599 1146.2725 560.3439 1169.9405 560.2439 1193.6045 560.4989 1196.1825 560.5269 1199.3245 562.0319 1201.1965 563.8769 1207.4825 570.0689 1213.4855 576.5769 1219.2255 583.2819 1221.2895 585.6919 1224.3685 586.2869 1226.0645 590.0199 1229.3115 597.1649 1227.4375 604.0969 1227.6675 611.0529 1227.7175 612.5539 1224.2815 615.0509 1222.0855 615.5829 1214.8345 617.3429 1207.4585 619.1799 1200.0505 619.6049 1176.6135 620.9509 1153.1425 622.3909 1129.6785 622.4999 1049.1795 622.8739 968.6765 622.3809 888.1795 622.980853 870.8025 623.1089 848.4755 610.1449 848.1635 584.3929 847.6885 545.3929 847.9955 506.3829 848.0935 467.3769 848.1615 440.5959 874.2365 424.7659 895.3495 424.783885 953.3505 424.8359 1011.3515 424.8029 1069.3515 424.8039 1089.5185 424.8039 1109.6855 424.7949 1129.8525 424.8049 1138.1915 424.8089 1140.1375 426.7209 1140.1365 434.8049 1140.1355 438.9359 1140.1355 443.0679 1140.1355 447.8149L1133.8625 447.8149C1052.8625 447.8269 971.8605 447.8379 890.8605 447.8509 874.6725 447.8539 867.4185 455.9369 869.1675 472.7049M1759.8243 495.8885C1760.9303 498.8925 1762.1273 500.7155 1762.2143 502.5895 1763.6343 533.5385 1739.1103 559.4525 1708.1923 559.7635 1693.0103 559.9165 1677.6813 559.8935 1663.3153 554.5575 1655.6953 551.7275 1648.5233 547.0565 1641.9843 542.1135 1634.4203 536.3945 1633.1283 527.1605 1631.9873 518.3815 1631.4133 513.9535 1631.3303 509.3235 1631.9873 504.9285 1632.3533 502.4795 1634.2323 499.7525 1636.2283 498.1405 1643.9173 491.9305 1655.6163 492.6995 1663.0973 500.1505 1667.7913 504.8255 1671.6523 510.3325 1675.9163 515.4445 1677.9413 517.8705 1679.8603 520.4285 1682.1673 522.5605 1683.3353 523.6395 1685.2573 523.9025 1686.8383 524.5345 1687.3583 522.5825 1688.7313 520.3605 1688.2173 518.7355 1687.2373 515.6455 1685.4173 512.7295 1683.5223 510.0385 1678.8293 503.3705 1673.6443 497.0375 1669.1753 490.2305 1667.1543 487.1525 1665.9093 483.3665 1665.1143 479.7265 1663.4363 472.0385 1666.7923 466.2205 1672.8043 461.5755 1682.9033 453.7745 1694.6523 450.3725 1707.0243 449.0585 1719.5263 447.7295 1732.0273 448.1095 1743.9243 452.8355 1761.5013 459.8175 1768.3693 477.4575 1760.3863 494.5565 1760.0363 495.3065 1759.7423 496.0835 1759.8243 495.8885"
                    />
                    <g transform="translate(244 461.981)">
                        <mask id="mask-large-b" fill="#fff">
                            <use xlinkHref="#mask-large-a" />
                        </mask>
                        <path
                            fill={color}
                            d="M0.0723,32.3088 C0.6493,24.0788 1.4473,15.1138 1.8363,6.1298 C2.0423,1.3708 4.5793,0.3148 8.4013,1.3368 C11.4143,2.1418 14.3833,3.3908 17.1143,4.9058 C21.7663,7.4828 26.3583,10.2198 30.7193,13.2568 C38.5843,18.7338 40.7843,25.4968 37.8453,34.6118 C33.8183,47.0958 29.4133,59.4658 25.7183,72.0458 C24.7043,75.4998 25.2593,79.5928 25.8743,83.2618 C26.1283,84.7798 28.2513,86.3858 29.8913,87.0678 C30.5373,87.3358 32.4763,85.3828 33.3293,84.1088 C37.9593,77.1978 42.3453,70.1218 46.9783,63.2128 C59.8983,43.9498 77.5313,46.1378 96.6813,56.2058 C99.9413,57.9198 102.0923,62.3898 103.9343,66.0048 C106.9483,71.9158 109.3503,78.1458 111.8963,84.2878 C114.7523,91.1778 118.5393,97.2378 124.8833,101.5858 C126.8033,102.9038 128.3263,105.2378 129.2803,107.4318 C130.9003,111.1598 130.0363,114.6428 125.7413,115.7688 C115.4943,118.4568 105.2603,122.1188 94.8263,122.9488 C79.4763,124.1678 63.7953,124.6818 48.5503,122.9288 C26.4323,120.3858 12.3953,106.7138 5.9553,85.4318 C0.7853,68.3448 -0.3217,50.7788 0.0723,32.3088"
                            mask="url(#mask-large-b)"
                        />
                    </g>
                    <path
                        fill={color}
                        d="M1422.0646 136.8289L1422.0646 121.7949C1425.7446 122.0119 1429.1866 122.5579 1432.5856 122.3569 1454.3376 121.0749 1476.1076 119.9589 1497.8176 118.1409 1519.0326 116.3629 1540.1826 113.8109 1561.3616 111.5999 1585.6836 109.0599 1610.0026 106.4789 1634.3316 103.9949 1658.3336 101.5429 1682.3226 98.9179 1706.3666 96.9739 1712.8816 96.4469 1719.5916 97.9809 1726.1716 98.8689 1727.6196 99.0629 1729.3966 100.2209 1730.1636 101.4649 1733.7936 107.3529 1737.1256 113.4249 1741.0856 120.3419 1733.6836 118.2059 1727.6586 116.1039 1721.4676 114.7569 1708.2256 111.8739 1694.9436 113.8699 1681.7006 115.1369 1659.3406 117.2769 1636.9906 119.5089 1614.6346 121.6959 1588.6366 124.2399 1562.6626 127.0589 1536.6336 129.2489 1500.8356 132.2599 1465.2326 138.1419 1429.1276 136.8389 1426.9806 136.7619 1424.8286 136.8289 1422.0646 136.8289M592.0543 120.6839L592.0543 135.3249C590.3293 135.4489 588.7433 135.6029 587.1543 135.6729 561.2663 136.8139 535.6293 133.7459 509.9573 131.1419 487.9423 128.9099 465.9083 126.8629 443.8853 124.6989 418.2213 122.1779 392.5623 119.6099 366.8993 117.0799 348.8513 115.3009 330.8313 113.0069 312.7403 111.9979 302.4203 111.4229 291.9823 112.9649 280.8293 113.5979 284.3913 108.2089 287.4593 101.8359 292.1923 97.1439 294.5213 94.8349 300.0043 94.8179 303.9373 95.1619 327.6353 97.2339 351.3023 99.6649 374.9693 102.0689 395.8233 104.1879 416.6643 106.4249 437.5113 108.6179 461.6643 111.1589 485.8123 113.7549 509.9713 116.2429 535.6293 118.8859 561.2503 122.2219 587.1523 120.6949 588.6143 120.6089 590.0843 120.6839 592.0543 120.6839M525.6827 479.1863C526.7097 480.1653 527.7577 481.1633 529.3687 482.6983 527.4987 483.0133 526.3017 483.3803 525.0997 483.3923 514.4547 483.4953 503.8077 483.4073 493.1667 483.6593 489.2817 483.7503 487.1697 482.5033 487.0457 478.4973 486.6627 466.2253 486.1677 453.9553 485.9497 441.6803 485.8747 437.4943 488.9567 435.3063 492.6197 434.7883 507.7117 432.6533 520.7687 437.5733 532.1237 447.2533 536.3307 450.8403 536.3257 455.8793 534.3697 460.6043 531.8377 466.7223 528.7817 472.6243 525.6827 479.1863M1720.1857 605.1414C1728.3417 602.3324 1737.9577 599.0214 1747.8017 595.6304L1747.8017 611.3144C1738.1407 609.1554 1728.4177 606.9814 1720.1857 605.1414M270.9981 614.2166L270.9981 600.7796C277.9741 602.7696 284.7871 604.7136 292.4521 606.9006 284.9381 609.4626 278.2091 611.7576 270.9981 614.2166"
                    />
                    <path
                        fill={color}
                        d="M563.4703 535.0711C563.2423 535.5101 559.9763 535.1321 558.8803 534.2101 556.1503 531.9151 553.8653 529.0921 550.5423 525.5691 555.3393 524.9801 558.7553 524.1551 562.1003 524.3811 563.2173 524.4551 564.8373 527.1481 565.0003 528.7681 565.2083 530.8401 564.4523 533.1801 563.4703 535.0711M613.0553 455.5511C589.9473 451.1331 568.2523 455.1521 548.9023 468.5841 543.4993 472.3351 538.3043 477.7951 540.6093 486.0741 541.4203 488.9881 541.7573 492.0341 542.3683 495.3281 525.5733 495.9041 509.2053 496.4651 491.6193 497.0671 494.4873 502.5831 496.8103 506.9231 498.9973 511.3291 499.7763 512.8981 500.6433 514.6061 500.7433 516.2951 501.0173 520.9131 500.4553 525.6121 501.0363 530.1751 502.2503 539.7171 502.8053 549.9421 511.1663 556.4211 516.9963 560.9391 523.4983 565.1641 530.3763 567.6451 547.9283 573.9801 566.3403 573.5061 584.6673 572.2261 594.2653 571.5571 603.5543 569.3641 611.0993 563.0171 627.4663 549.2501 635.1283 531.2361 636.1673 510.1041 636.3013 507.3831 636.7083 504.5081 637.7513 502.0241 646.7683 480.5571 635.9833 459.9351 613.0553 455.5511M1432.6661 531.7293C1429.4071 524.4083 1432.4881 518.9733 1433.8121 512.3823 1436.4571 514.0803 1438.6151 515.4633 1441.1161 517.0673 1438.3961 521.7873 1435.8191 526.2583 1432.6661 531.7293M1524.1951 476.0963C1529.3381 477.1133 1531.0371 474.6033 1530.9451 469.8773 1530.7811 461.3903 1531.0551 452.8833 1530.5631 444.4173 1530.0891 436.2433 1527.0301 433.5193 1518.6661 432.5783 1506.4111 431.1983 1495.3271 434.8833 1484.7641 440.6273 1475.3051 445.7703 1473.2071 452.5103 1478.2051 462.1293 1481.1911 467.8773 1484.0011 473.8153 1487.7651 479.0373 1491.9021 484.7763 1490.4861 489.3663 1486.1251 494.9573 1481.8101 489.8953 1477.6951 484.9963 1473.5011 480.1663 1465.5981 471.0623 1456.4481 465.9283 1443.9681 470.5693 1442.6371 471.0633 1440.3411 470.2273 1439.0201 469.2753 1431.8761 464.1253 1425.0291 458.5563 1417.8071 453.5233 1414.0381 450.8973 1411.1361 452.3943 1410.6371 456.8513 1410.0441 462.1393 1409.7491 467.4623 1409.4191 472.7773 1408.2781 491.1553 1408.9791 509.4093 1414.0611 527.2283 1419.6561 546.8493 1432.1591 559.5273 1452.5141 563.2953 1459.6611 564.6183 1467.0631 564.8763 1474.3601 565.0093 1489.3541 565.2823 1504.3651 564.9753 1518.6671 559.6703 1520.9721 558.8153 1524.3591 556.2783 1524.2841 554.6543 1524.1641 552.0273 1521.8301 549.3193 1519.9791 547.0063 1518.2851 544.8913 1515.2551 543.6253 1514.1051 541.3353 1510.9061 534.9643 1508.4441 528.2273 1505.5501 521.6983 1504.5271 519.3903 1505.0071 518.1713 1507.2361 516.9563 1509.6861 515.6213 1512.7601 514.2273 1513.9491 511.9983 1518.9851 502.5583 1523.4221 492.7983 1527.9741 483.3703 1525.1531 480.7973 1519.4101 482.1663 1521.9251 476.3143 1522.5971 476.2403 1523.4391 475.9473 1524.1951 476.0963"
                    />
                </g>
            </S.Mask>
            <S.Image
                src="/assets/booths/Appendee_Stand_Large_Color.png"
                alt=""
                style={{ zIndex: 2 }}
            />
            {logo && (
                <S.Logo src={logo} alt="" style={{ zIndex: 5 }} />
            )}
            {video?.embedded_url && isActiveBooth && (
                <S.VideoThumbnail>
                    <EmbeddedVideo url={video.embedded_url} />
                </S.VideoThumbnail>
            )}
        </S.Container>
    )
}

export default StandLarge
